"use client";

import { useEffect, useState } from "react";
import { Play } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function CoastlineHero() {
  const [currentTime, setCurrentTime] = useState("06:00");
  useEffect(() => {
    const times = ["06:00", "09:00", "12:00", "15:00", "18:00", "21:00"];
    let index = 0;
    const interval = setInterval(() => {
      index = (index + 1) % times.length;
      setCurrentTime(times[index]);
    }, 3000);
    return () => clearInterval(interval);
  }, []);
  return <section data-section-id="2838" id="coastlinehero" className="relative min-h-screen w-full overflow-hidden bg-background text-foreground">
      {}
      <div className="absolute inset-0 z-0">
        <video autoPlay loop muted playsInline className="h-full w-full object-cover" poster="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717132/img/climate_control_comfort.png">
          <source src="/img/climate_control_comfort.mp4" type="video/mp4" />
        </video>
        {}
        <div className="absolute inset-0 bg-gradient-to-br from-blue-900/80 to-blue-600/40" />
      </div>

      {}
      <div className="pointer-events-none absolute inset-x-4 inset-y-4 z-10 border border-blue-200/20 md:inset-x-8 md:inset-y-8" aria-hidden="true" />

      {}
      <div className="absolute left-8 top-8 z-20 md:left-12 md:top-12">
        <span className="font-default text-xs tracking-widest uppercase text-blue-100/80">
          {currentTime} <span className="mx-1 opacity-50">→</span> 21:00
        </span>
      </div>

      {}
      <div className="absolute right-8 top-8 z-20 md:right-12 md:top-12">
        <span className="font-default text-xs tracking-[0.3em] uppercase text-blue-100/80">
          COASTLINE
        </span>
      </div>

      {}
      <div className="relative z-20 flex min-h-screen flex-col justify-end px-8 pb-24 pt-32 md:justify-start md:px-16 md:pt-[60vh] md:pb-16 lg:px-24">
        <div className="max-w-4xl">
          <h1 className="font-default font-light leading-[0.95] tracking-tight text-white" style={{
          fontSize: "clamp(3.5rem, 10vw, 10rem)"
        }}>
            Perfect Climate,{" "}
            <em className="italic font-normal text-blue-300">
              Refined.
            </em>
            <br />
            For Every Space.
          </h1>

          <p className="mt-8 max-w-xl font-default text-lg md:text-xl text-blue-50/75">
            Premium air conditioning and climate control solutions for homes and businesses across Sussex and Surrey.
          </p>

          {}
          <div className="mt-10 flex flex-col gap-4 sm:flex-row sm:items-center">
            <Button asChild size="lg" className="h-14 bg-blue-600 px-8 font-default text-xs uppercase tracking-[0.2em] text-white hover:bg-blue-700 rounded-lg w-full sm:w-auto shadow-lg">
              <Link to="/AirConditioningPage">
                Book Your Installation
              </Link>
            </Button>

            <Button asChild variant="ghost" size="lg" className="h-14 px-8 font-default text-xs uppercase tracking-[0.2em] text-white border border-white/30 hover:bg-white/10 hover:text-white rounded-lg w-full sm:w-auto backdrop-blur-sm">
              
            </Button>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-12 right-8 z-20 hidden md:flex md:right-12 lg:right-16">
        <div className="flex flex-col items-center gap-4">
          <span className="font-default text-xs tracking-[0.3em] uppercase [writing-mode:vertical-rl] rotate-180 text-blue-100/80">
            Scroll — COOL
          </span>
          <div className="relative h-20 w-px overflow-hidden bg-blue-100/20">
            <div className="absolute top-0 left-0 w-full animate-scroll-line" style={{
            height: "40%",
            background: "linear-gradient(to bottom, transparent, hsl(225, 73%, 57%), transparent)"
          }} />
          </div>
        </div>
      </div>

      <style>{`
        @keyframes scroll-line {
          0% { transform: translateY(-100%); }
          100% { transform: translateY(250%); }
        }
        .animate-scroll-line {
          animation: scroll-line 2s ease-in-out infinite;
        }
      `}</style>
    </section>;
}